export default __webpack_public_path__ + "static/media/checkup.69e6a41c.png";